import { render, staticRenderFns } from "./ProductsCompany.vue?vue&type=template&id=3a1ba254&scoped=true&"
import script from "./ProductsCompany.vue?vue&type=script&lang=js&"
export * from "./ProductsCompany.vue?vue&type=script&lang=js&"
import style0 from "./ProductsCompany.vue?vue&type=style&index=0&id=3a1ba254&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1ba254",
  null
  
)

export default component.exports